import { render, staticRenderFns } from "./PostShare.vue?vue&type=template&id=32943daa&scoped=true&"
import script from "./PostShare.vue?vue&type=script&lang=js&"
export * from "./PostShare.vue?vue&type=script&lang=js&"
import style0 from "./PostShare.vue?vue&type=style&index=0&id=32943daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32943daa",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PostShare.vue
// module id = 346
// module chunks = 0